import types from './action-types';
import { produce } from 'immer';
import moment from 'moment'
import { DisplayModeOption } from './filter';

const initialState = {
    zoom: 10,
    loading: false,
    loaded: false,
    projects: [],
    auxiliaryDrawingLayers: [],
    projectId: 0,
    refresh: 0,
    filterClosed: true,
    selectedDisplayMode: DisplayModeOption.NAME
};

function processLOADING(draft) {
    draft.loading = true;
    draft.loaded = false;
}

function processDATA_LOADED(draft, action) {
    draft.loading = false;
    draft.loaded = true;
    action.data.projects.forEach(p => {
        draft.projects.unshift(p);
    });
    draft.gisLabelDisplayZoom = action.data.gisLabelDisplayZoom;
    draft.linkedProjectsCount = action.data.linkedProjectsCount;
    draft.cacheKey = action.data.cacheKey;
    draft.cachedTime = action.data.cachedTime;
}

function processLINKEDDATA_LOADED(draft, action) {
    action.data.projects.forEach(p => {
        draft.projects.push(p);
    });
}

function updateExcavations(visible, project, axis) {
    axis.showExcavations = visible;
    axis.showTitle = axis.chapters.some(chapter => chapter.visible) || axis.showExcavations;
    axis.visible = axis.chapters.every(chapter => chapter.visible) && axis.showExcavations;
    project.visible = project.axes.every(axis => axis.visible) && project.auxDrawingsVisible;
}

function filterProfile(profile, visible) {
    profile.visible = visible;
    if (profile.faceData) {
        profile.faceData.forEach(face => {
            face.visible = visible;
        });
    }
}

function updateProfile(visible, project, axis, chapter, profileId) {
    const profile = chapter.profiles.find(x => x.id == profileId);
    filterProfile(profile, visible);
    chapter.visible = chapter.profiles.every(profile => profile.visible);
    axis.showTitle = axis.chapters.some(chapter => chapter.visible) || axis.showExcavations;
    axis.visible = axis.chapters.every(chapter => chapter.visible) && axis.showExcavations;
    project.visible = project.axes.every(axis => axis.visible) && project.auxDrawingsVisible;
}

function updateChapter(visible, project, axis, chapter) {
    chapter.visible = visible;
    chapter.profiles.forEach(profile => {
        filterProfile(profile, visible);
    });
    axis.showTitle = axis.chapters.some(chapter => chapter.visible) || axis.showExcavations;
    axis.visible = axis.chapters.every(chapter => chapter.visible) && axis.showExcavations;
    project.visible = project.axes.every(axis => axis.visible) && project.auxDrawingsVisible;
}

function updateAxis(visible, project, axis) {
    axis.visible = visible;
    axis.showExcavations = visible;
    axis.showTitle = visible;
    axis.chapters.forEach(chapter => {
        chapter.visible = visible;
        chapter.profiles.forEach(profile => filterProfile(profile, visible));
    });
    project.visible = project.axes.every(axis => axis.visible) && project.auxDrawingsVisible;
}

function updateProject(visible, project) {
    project.visible = visible;
    project.axes.forEach(axis => {
        axis.visible = visible;
        axis.showExcavations = visible;
        axis.showTitle = visible;
        axis.chapters.forEach(chapter => {
            chapter.visible = visible;
            chapter.profiles.forEach(profile => filterProfile(profile, visible));
        });
    });
    project.auxDrawingsVisible = visible;
    project.auxDrawings.forEach(drawing => {
        drawing.visible = visible;
    });
}

function processFILTER_CHANGED(draft, action) {
    // for project there is only projectId filled, for axis there is projectId + axisId filled, for chapter there is projectId + axisId + chapterId and so on..
    const { projectId, axisId, chapterId, profileId, visible } = action.data;
    const project = draft.projects.find(x => x.id == projectId);
    if (axisId != null) {
        const axis = project.axes.find(x => x.id == axisId);
        if (chapterId != null) {
            if (chapterId == -1) {
                updateExcavations(visible, project, axis);
            } else {
                const chapter = axis.chapters.find(x => x.id == chapterId);
                if (profileId != null) {
                    updateProfile(visible, project, axis, chapter, profileId);
                } else {
                    updateChapter(visible, project, axis, chapter);
                }
            }
        } else {
            updateAxis(visible, project, axis);
        }
    } else {
        updateProject(visible, project);
    }
}

function updateDrawing(visible, project, drawingId) {
    const drawing = project.auxDrawings.find(x => x.id == drawingId);
    drawing.visible = visible;
    project.auxDrawingsVisible = project.auxDrawings.every(ad => ad.visible);
    project.visible = project.axes.every(axis => axis.visible) && project.auxDrawingsVisible;
}

function updateAllDRawings(visible, project) {
    project.auxDrawingsVisible = visible;
    project.auxDrawings.forEach(ad => {
        ad.visible = visible;
    })
    project.visible = project.axes.every(axis => axis.visible) && project.auxDrawingsVisible;
}

function processAUXDRAWINGS_CHANGED(draft, action) {
    // for project there is only projectId filled, for drawing there is projectId + drawingId filled
    const { projectId, drawingId, visible } = action.data;
    const project = draft.projects.find(x => x.id == projectId);
    if (drawingId != null) {
        updateDrawing(visible, project, drawingId);
    } else {
        updateAllDRawings(visible, project);
    }
}

function processDATE_FILTER_CHANGED(draft, action) {
    const { dateFrom, dateTo } = action.data;
    const inFilteredDateRange = date => moment(date).isBetween(dateFrom, dateTo, 'day', '[]'); // ignore time, compare just day, inclusive comparison
    draft.projects.forEach(project => {
        project.axes.forEach(axis => {
            axis.chapters.forEach(chapter => {
                chapter.profiles.forEach(profile => {
                    profile.visible = profile.dates.some(date => inFilteredDateRange(date));
                    if (profile.faceData != null) { // if face data profile, set visibility on face files
                        profile.faceData.forEach(face => {
                            face.visible = inFilteredDateRange(face.date);
                        });
                    }
                });
                chapter.visible = chapter.profiles.some(profile => profile.visible); // adjust chapter visibility by child profiles
            });
            axis.visible = axis.chapters.some(chapter => chapter.visible); // adjust axis visibility by child chapters
        });
    })
}

export default (state = initialState, action) => {

    return produce(state, draft => {
        switch (action.type) {
            case types.LOADING:
                processLOADING(draft);
                break;
            case types.DATA_LOADED:
                processDATA_LOADED(draft, action);
                break;
            case types.LINKEDDATA_LOADED:
              processLINKEDDATA_LOADED(draft, action);
                break;
            case types.FILTER_CHANGED:
                processFILTER_CHANGED(draft, action)
                break;
            case types.AUXDRAWINGS_CHANGED:
                processAUXDRAWINGS_CHANGED(draft, action);
                break;
            case types.DATE_FILTER_CHANGED:
                processDATE_FILTER_CHANGED(draft, action);
                break;
            case types.DISPLAY_MODE_CHANGED:
                draft.selectedDisplayMode = action.data.selectedDisplayMode;
                break;
            case types.ZOOM_CHANGED:
                draft.zoom = action.data.zoom;
                break;
            case types.TOGGLE_FILTER:
                draft.filterClosed = !action.data.visible;
                break;
        }
    });
}


// WEBPACK FOOTER //
// ./App/components/modules/gis-map/reducer.js